import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData, selectExtraRoutesAuthData } from '@/containers/Login/AuthSelectors'
import { updateAdditionalSalesData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { selectAdditionalSalesConfig } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import {
  selectPersonalContactSubscriptionData,
  selectPreferencesContactSubscriptionData,
  selectProfessionalContactSubscriptionData,
} from '../../SubscriptionForm/SubscriptionFormSelectors'

const useAdditionalSaleFormData = () => {
  const dispatch = useDispatch()
  const { zohoId, firstName, lastName, civility, phone1, phone2, email, birthdate } = useSelector(
    selectPersonalContactSubscriptionData,
  )

  const { socialReason, siret } = useSelector(selectProfessionalContactSubscriptionData)
  const { clientType } = useSelector(selectPreferencesContactSubscriptionData)

  const { sales: additionalSales } = useSelector(selectAdditionalSalesConfig)

  const { saveAdditionalSaleLeadUrl } = useSelector(selectExtraRoutesAuthData) || {}
  const { retryAdditionalSaleLeadUrl } = useSelector(selectExtraRoutesAuthData) || {}
  const { iban = '', bic } = {} // useSelector(selectBillingSubscriptionData)
  const { isMcpAgent, country } = useSelector(selectAuthData)
  const { streetNumber, city, zipcode, address, inseeCode, housingType, tenantType } = {} // useSelector(
  // selectMainAddressSubscriptionData,
  // )
  const { prestationType } = {} //  useSelector(selectEnergyCharacteristicsSubscriptionData)

  const { providerId } = {} // useSelector(selectTelecomContractSubscriptionData)

  const { type: businessType } = useBusinessType({
    loaderRoutesEnergy: {},
    loaderRoutesInsurance: {},
    loaderRoutes: {},
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })

  const findProductInList = (products, name) => {
    const product = products.find(o => o.name === name)
    if (product === 'undefined') {
      return ''
    }
    return product
  }

  const findProductById = (products, id) => {
    const product = products.find(o => o.id === parseInt(id))
    if (product === 'undefined') {
      return ''
    }
    return product
  }

  const subscription = null
  /* const isAlreadyMonConseillerPerso =
    !!subscription?.sale_mon_conseiller_perso && subscription.sale_mon_conseiller_perso.status_code !== 'abandon' */
  const { token, isEditable, mandatoryFields, errors } = {} // useSelector(selectCommonFormConfigurationData)
  const agentEmail = subscription?.created_by?.email ?? ''

  const retrieveProductsListOfSale = saleName => {
    if (!additionalSales[saleName]) {
      return []
    }
    return additionalSales[saleName].sales || []
  }

  const retrieveResourcesOfSale = saleName => {
    if (!additionalSales[saleName]) {
      return []
    }
    return additionalSales[saleName].resources || []
  }

  const updateLead = (data, name) => {
    dispatch(updateAdditionalSalesData({ data, name }))
  }

  return {
    zohoId,
    firstName,
    lastName,
    civility,
    phone1,
    phone2,
    email,
    birthdate,
    socialReason,
    siret,
    prestationType,
    clientType,
    iban,
    bic,
    streetNumber,
    city,
    zipcode,
    address,
    inseeCode,
    agentEmail,
    housingType,
    tenantType,
    country,
    providerId,
    token,
    isEditable,
    businessType,
    mandatoryFields,
    errors,
    updateLead,
    retrieveProductsListOfSale,
    findProductInList,
    retrieveResourcesOfSale,
    findProductById,
    saveAdditionalSaleLeadUrl,
    retryAdditionalSaleLeadUrl,
    showOnlyAllowLeadMcp: false, // todo-v2: check this !isMcpAgent && isAlreadyMonConseillerPerso,
    haveAlreadyAnyLead:
      !!subscription?.sale_telecom_energy ||
      !!subscription?.sale_telecom ||
      !!subscription?.sale_verisure_telecom ||
      !!subscription?.sale_assurance_default ||
      !!subscription?.sale_assurance_emprunteur,
  }
}

export default useAdditionalSaleFormData
